<ng-container *transloco="let t">
  <main>
    <h3>פרטי הקבלן המבצע</h3>

    <section *ngIf="!(readonly || printPreview)">
      <nz-space>
        <ng-template nzSpaceItem>
          <button mat-raised-button color="accent" (click)="selectContractor()">
            בחר קבלן
          </button>
        </ng-template>
        <ng-template nzSpaceItem>
          <button mat-raised-button color="accent" (click)="newContractor()">
            הוסף קבלן חדש
          </button>
        </ng-template>
        <ng-template nzSpaceItem></ng-template>
      </nz-space>
    </section>
    <br />

    <section>
      <mat-form-field floatLabel="always">
        <mat-label>שם הקבלן</mat-label>
        <input
          type="text"
          matInput
          placeholder="{{ t('name') }}"
          [(ngModel)]="contractor.name"
          readonly
        />
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>טלפון</mat-label>
        <input
          type="text"
          matInput
          placeholder="{{ t('phone') }}"
          [(ngModel)]="contractor.phone"
          readonly
        />
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>מייל</mat-label>
        <input
          type="text"
          matInput
          placeholder="{{ t('email') }}"
          [(ngModel)]="contractor.email"
          readonly
        />
      </mat-form-field>

      <br />

      <mat-form-field floatLabel="always">
        <mat-label>תפקיד</mat-label>
        <input
          type="text"
          matInput
          placeholder="{{ t('jobTitle') }}"
          [(ngModel)]="contractor.jobTitle"
          readonly
        />
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>כתובת</mat-label>
        <input
          type="text"
          matInput
          placeholder="{{ t('address') }}"
          [(ngModel)]="contractor.address"
          readonly
        />
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>ח.פ.</mat-label>
        <input
          type="text"
          matInput
          placeholder="{{ t('companyNumber') }}"
          [(ngModel)]="contractor.companyNumber"
          readonly
        />
      </mat-form-field>
      <button
        mat-raised-button
        color="accent"
        (click)="editContractor()"
        *ngIf="!(readonly || printPreview)"
      >
        עריכה
      </button>
    </section>
  </main>
</ng-container>
